import React, { memo } from 'react';
import PropTypes from '../../types';

import { Form } from 'react-final-form';
import Submit from '../../components/Submit';
import BusinessMandateGroup from './BusinessMandateGroup';

const BusinessMandatePage = memo(function BusinessMandatePage({
  saveBusinessMandatePage,
  getBusinessData
}) {
  return (
    <Form
      onSubmit={saveBusinessMandatePage}
      initialValues={getBusinessData}
      render={({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit}>
          <BusinessMandateGroup values={values} />
          <Submit />
        </form>
      )}
    />
  );
});

BusinessMandatePage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveBusinessMandatePage: PropTypes.func.isRequired
};

export default BusinessMandatePage;
